export default {
  Company: {
    keyFields: ['company_uuid']
  },
  // Layout is keyed by layout_uuid (not `id`), so without this an updated layout returned by
  // layoutUpdate is not normalized into the cached LAYOUTS_QUERY list. With it, an autosave update's
  // result merges into the list by identity — the list stays fresh (name/updated_at/integrations)
  // with no refetch.
  Layout: {
    keyFields: ['layout_uuid']
  },
  TradingPartner: {
    keyFields: ['partner_uuid']
  },
  FlowExecution: {
    keyFields: ['invocation_uuid']
  },
  Memo: {
    keyFields: ['memo_uuid']
  },
  Milestone: {
    keyFields: ['milestone_uuid']
  },
  FlowSetup: {
    keyFields: ['flow_uuid']
  },
  FlowVersion: {
    keyFields: ['flow_uuid', 'version_timestamp']
  },
  FlowConfiguration: {
    keyFields: ['flow_uuid']
  },
  LogJob: {
    keyFields: ['job_uuid']
  },
  FileType: {
    keyFields: ['code']
  },
  Endpoint: {
    keyFields: ['endpoint_uuid']
  },
  HostSystem: {
    keyFields: ['host_system_uuid']
  }
}
